/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {accounting} from 'accounting'
import {message} from 'antd'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import HeaderGrid from '../Pagination/HeaderGrid'

class UserTransaction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printInfo: [],
      buttonClicked: false,
      transaction: [],
      fromDate: '',
      toDate: '',
      fromPrintDate: '',
      toPrintDate: '',
      customerCode: '',
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ ثبت',
          value: 'registerDate',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه تراکنش',
          value: 'transactionId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شناسه پرداخت',
          value: 'paymentId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نوع پرداخت',
          value: 'paymentMethodName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'شرح پرداخت',
          value: 'paymentDescription',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مبلغ تراکنش',
          value: 'amount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'مانده',
          value: 'amountSum',
          sorted: false,
          direction: null,
          sortable: true
        }
      ]
    }
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_SINGLE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()
            this.setState({
              transaction: response.data.object.result,
              countAll: response.data.object.countAll,
              buttonClicked: true,
              loading: false
            })
          } else {
            this.setState({
              loading: false,
              printInfo: response.data.object.result,
              lengthRemains: response.data.object.countAll,
              name: response.data.object.result[0].customer.name,
              remainAmount: response.data.object.result[0].remainAmount
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            transaction: [],
            countAll: 0,
            loading: false
          })
          message.error(response.data.description)
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  loadTransactionFromQuery = (customerCode) => {
    let params = {
      pageNumber: 1,
      pageSize: 10,
      export: false,
      customerCode
    }
  }

  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    var userCode = urlParams.get('userCode') === null ? '' : urlParams.get('userCode')

    if (!(userCode === '')) {
      this.setState(
        {
          customerCode: userCode
        },
        () => {
          sessionStorage.setItem('pageNumber', '1')
          sessionStorage.setItem('dropDownVal', '10')
          sessionStorage.setItem('params', `customerCode=${userCode}&sortAscending=${0}`)
          this.getReport(false)
        }
      )
    } else {
      sessionStorage.setItem('params', '')
    }

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  getSingleCustomerCode = (customerCode) => {
    this.setState({
      customerCode
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let registerDateMin = this.state.fromDate
    let registerDateMax = this.state.toDate
    let customerCode = this.state.customerCode
    let sortAscending = document.getElementById('sortAscending').value

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (customerCode !== '') {
      filter.customerCode = customerCode.trim()
    }
    if (sortAscending !== '') {
      filter.sortAscending = sortAscending
    }
    if (registerDateMin !== '') {
      filter.registerDateMin = registerDateMin
    }
    if (registerDateMax !== '') {
      filter.registerDateMax = registerDateMax
    }
    return filter
  }

  filter() {
    if (this.state.customerCode === '') {
      message.error('کد مشتری وارد شود')
    } else {
      let registerDateMin = this.state.fromDate
      let registerDateMax = this.state.toDate
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
          this.setState({
            toPrintDate: registerDateMax == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            fromPrintDate: registerDateMin == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD')
          })
        }
      )
    }
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_CUSTOMER_TRANSACTION_SINGLE}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result,
            name: response.data.object.result[0].customer.name
          })
          let {excelReport} = this.state

          let result = response.data.object.result
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['registerDate'] = jMoment(excelReport[i]['registerDate']).format('jYY/jM/jD HH:mm')
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  render() {
    let name = cookie.load('name')
    let columns = [
      'ردیف',
      'تاریخ ثبت',
      'شناسه تراکنش',
      'شناسه فاکتور',
      'شناسه پرداخت',
      'نوع پرداخت',
      'شرح پرداخت',
      'مبلغ هر تراکنش',
      'مانده'
    ]

    let {pageNumber, pageSize, loading} = this.state

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش تراکنش های کاربر "
              headerColSpan={9}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={3}
              centerColSpan={3}
              centerSection={' برای : ' + this.state.name + ' - ' + ' مانده از قبل : ' + this.state.remainAmount}
              rightSection={' تاریخ از ' + this.state.fromPrintDate + ' تا ' + this.state.toPrintDate}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((transaction, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{jMoment(transaction.registerDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{transaction.transactionId}</td>
                  <td>{transaction.invoiceId}</td>
                  <td>{transaction.paymentId}</td>
                  <td>{transaction.payment === null ? '-' : transaction.payment.methodName}</td>
                  <td>{transaction.payment === null ? '-' : transaction.payment.description}</td>
                  <td className="priceCell">{accounting.formatMoney(transaction.amount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(transaction.amountSum, '', ',')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش تراکنش های : ' + this.state.name + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'registerDate'}
                field={'registerDate'}
                title={'تاریخ ثبت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'transactionId'}
                field={'transactionId'}
                title={'شناسه تراکنش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoiceId'}
                title={'شناسه فاکتور'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'paymentId'}
                field={'paymentId'}
                title={'شناسه پرداخت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'methodName'}
                field={'payment.methodName'}
                title={'نوع پرداخت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'description'}
                field={'payment.description'}
                title={'شرح پرداخت'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'amount'}
                field={'amount'}
                title={'مبلغ تراکنش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'amountSum'}
                field={'amountSum'}
                title={'مانده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>گزارش تراکنش های کاربر</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <SearchCustomer
                  label={'کد مشتری'}
                  getSingleCustomerCode={this.getSingleCustomerCode}
                  singleResult={true}
                  searchLabel={'جست و جوی مشتری'}
                  getValueFromThisPage={this.state.customerCode}
                  force={true}
                />
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت از"
                  toLabel="تاریخ ثبت تا"
                  defaulValue={false}
                  fromId="registerDateMin"
                  toId="registerDateMax"
                />
                <div className="formComponent">
                  <label>ترتیب نمایش</label>
                  <select className="form-control" id="sortAscending">
                    <option value={0}>نزولی</option>
                    <option value={1}>صعودی</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.transaction.map((transaction, index) => (
                    <tr key={index}>
                      <td>
                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                      </td>
                      <td>{jMoment(transaction.registerDate).format('jYY/jM/jD HH:mm')}</td>
                      <td>{transaction.transactionId}</td>
                      <td>
                        <Link target="_blank" to={`/baskets?invoiceId=${transaction.invoiceId}`}>
                          {transaction.invoiceId}
                        </Link>
                      </td>
                      <td>{transaction.paymentId}</td>
                      <td>{transaction.payment === null ? '-' : transaction.payment.methodName}</td>
                      <td>{transaction.payment === null ? '-' : transaction.payment.description}</td>
                      <td className="priceCell ltrTd">{accounting.formatMoney(transaction.amount, '', ',')}</td>
                      <td className="priceCell ltrTd">{accounting.formatMoney(transaction.amountSum, '', ',')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default UserTransaction
